import React, {  useState } from "react";
import styled from 'styled-components'
import tw from "twin.macro";
import { useForm } from "react-hook-form";
import { questionMark } from "./PaymentForm";
import { HtmlTooltip } from "../../../components/InputField";
import axios from "axios";
import { getURI } from "../../../helpers/apiHelpers";
import GenericModal from "../../Dashboard/components/GenericModal";


const Input = styled.input`  
  ${tw`rounded-md  pl-3 pr-2 py-2 border-2 border-gray-200 placeholder-gray-300`}
`

const TextArea = styled.textarea`  
  ${tw`rounded-md  pl-3 pr-2 py-2 border-2 border-gray-200 placeholder-gray-300`}
`

const Submit = styled.button`
  font-size: 16px;
  color: white;
  font-family: Varela Round;
  border-radius: 3px;
  ${tw`bg-primaryBlue h-10 px-8`}
  ${props => props.disabled && tw`text-fontBlue bg-disabled cursor-not-allowed`}
`

const UserInfo = (props) => {
    const { userData, getCompanyInfo } = props;

    const [state, setState] = useState({
        firstName: userData.firstName,
        lastName: userData.lastName,
        businessName: userData.businessName,
        email: userData.email,
        mobile: userData.mobile,
        billingAddress: userData.billingAddress,
        apiCode: userData.apiCode,
        modal:false
    })

    const setModal = (data) => {
        setState(state => ({ ...state, modal: data }));
    }



    const {  register, handleSubmit, formState: { errors } } = useForm();

    

    const cleanBillingAddress = (billingAddress) => {
        return billingAddress.split(',').map(address => address.trim()).join(', ');
    }

    const onSubmit = (data) => {
        data.billingAddress = cleanBillingAddress(data.billingAddress);

        axios
            .patch(getURI('/api/user/update-user'), data)
            .then(() => {
                getCompanyInfo(data.api_key);
                setModal(true);
            })
            .catch(e => {

            })

        // refresh();
    }



    return (
        <>
        <form className="flex flex-wrap gap-3 w-full p-5" onSubmit={handleSubmit(onSubmit)}>
            <label className="relative  flex flex-col w-1/3">
                <span className="font-medium flex items-center gap-3 mb-3">
                    First Name
                </span>
                <Input
                    type="text"
                    placeholder="&bull;&bull;&bull;"
                    {...register("firstName", { required: true, maxLength: 191, minLength: 1, value: state.firstName })}
                />
            </label>
            <label className="relative  flex flex-col w-1/3">
                    <span className="font-medium flex items-center gap-3 mb-3">
                    Last Name
                </span>
                <Input
                    type="text"
                    placeholder="&bull;&bull;&bull;"
                    {...register("lastName", { required: true, maxLength: 191, minLength: 1, value: state.lastName })}
                />
            </label>
            <label className="relative flex-1 flex flex-col w-1/3">
                <span className="font-medium flex items-center gap-3 mb-3">
                    Business Name
                </span>
                <Input
                    type="text"
                    placeholder="&bull;&bull;&bull;"
                    {...register("businessName", { required: true, maxLength: 191, minLength: 1, value: state.businessName })}
                />
            </label>            
            <label className="relative  flex flex-col w-1/3">
                <span className="font-medium flex items-center gap-3 mb-3">
                    E-mail
                </span>
                <Input
                    type="text"
                    placeholder="&bull;&bull;&bull;"
                    {...register("email", {
                        required: true, maxLength: 191, minLength: 1, value: state.email, pattern: {
                            value: /\S+@\S+\.\S+/,
                            message: "Entered value does not match email format"
                        } })}
                />
            </label>
            <label className="relative  flex flex-col w-1/3">
                <span className="font-medium flex items-center gap-3 mb-3">
                        Mobile Number
                        <span className="relative">
                            <HtmlTooltip
                                style={{ marginLeft: 7 }}
                                placement="top"
                                title="Enter 10 digits only">
                                {questionMark}
                            </HtmlTooltip>
                        </span>
                </span>
                <Input
                    type="text"
                    placeholder="&bull;&bull;&bull;"
                    {...register("mobile", { required: true, maxLength: 10, minLength: 10, value: state.mobile })}
                />
            </label>
            <label className="relative flex-1 flex flex-col w-1/2">
                <span className="font-medium flex items-center gap-3 mb-3">
                    Billing E-mail
                    <span className="relative">
                        <HtmlTooltip
                            style={{ marginLeft: 7 }}
                            placement="top"
                            title="Separate multiple emails by commas">
                            {questionMark}
                        </HtmlTooltip>
                    </span>
                </span>
                <TextArea
                    placeholder="&bull;&bull;&bull;"
                    {...register("billingAddress", { required: false, maxLength: 191, minLength: 1, value: state.billingAddress })}
                />
            </label>

            <input type="hidden" {...register("api_key", { value: state.apiCode })} />

            <div className="relative flex-1 flex flex-col w-1/2 v">
                <Submit type="submit" className="self-end mt-auto">Submit Changes</Submit>
            </div>

            <GenericModal
                contentLabel="Success"
                modalIsOpen={state.modal}
                setModalIsOpen={setModal}
                content="Data Saved Succesfully"
            />
            
        </form>
    <div>
                {errors.firstName && <><span style={{ color: 'red' }}>Please Add User First Name</span><br /></>}
                {errors.lastName && <><span style={{ color: 'red' }}>Please Add User Last Name</span><br /></>}
                {errors.businessName && <><span style={{ color: 'red' }}>Please Add User Business Name</span><br /></>}
                {errors.email && <><span style={{ color: 'red' }}>Please Add User E-mail & Verify Format</span><br /></>}
                {errors.mobile && <><span style={{ color: 'red' }}>Please Add User Mobile Only 10 Digits Are Accepted</span><br /></>}
            </div></>);
};

export default UserInfo;